import React from 'react';
import { I18n } from 'react-redux-i18n-lite';

const TOKEN_PATTERN = /(%\{\w+\})/;

/**
 * Translates `key` and swaps each %{token} for its node. I18n leaves unknown placeholders untouched,
 * so the raw text still carries them.
 */
export const translateWithTokens = (key, tokens = {}) =>
  I18n.t(key)
    .split(TOKEN_PATTERN)
    .filter(Boolean)
    .map((part, index) => {
      const match = part.match(/^%\{(\w+)\}$/);
      const node = match ? tokens[match[1]] : null;
      return <React.Fragment key={index}>{node || part}</React.Fragment>;
    });
